import { useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import { wrapPromise } from "../../../utils/promise";
import {
  getAvailableMergeSplitStops,
  getSelectedStops,
  getLeadStop,
} from "../../../store/selectors/ui/routeDetail";
import { mergeStops, onMergeStopPick } from "../../../store/actions/stop";

export default () => {
  const mergeStopsModalRef = useRef();
  const dispatch = useDispatch();

  const dropdownListStops = useSelector(getAvailableMergeSplitStops);
  const selectedStops = useSelector(getSelectedStops);
  const leadStop = useSelector(getLeadStop);
  const handleMergeStopPick = useCallback(
    (pickedStop) => dispatch(onMergeStopPick(pickedStop)),
    [dispatch]
  );

  const openMergeStopsModal = useCallback(async () => {
    const [stop, canceled] = await wrapPromise(
      mergeStopsModalRef.current.showModal({
        availableStops: dropdownListStops,
        selectedStops,
        leadStop,
        handleMergeStopPick,
      })
    );
    if (canceled) return;

    dispatch(mergeStops(stop));
  }, [
    dispatch,
    dropdownListStops,
    handleMergeStopPick,
    selectedStops,
    leadStop,
  ]);

  return {
    mergeStopsModalRef,
    openMergeStopsModal,
  };
};
